export default __webpack_public_path__ + "static/ASLA_Linia_3-beac3aafc9bc987c2e9c0813dbf8891f.png";